import { createSelector } from '@reduxjs/toolkit'

import { extractFabrication } from '../utils/extracter';
//import { USA_QUICKTURN_ID } from '../data/productVariants';

const selectFabricationParametersCustomer = (state) => state.fabrication?.parametersCustomer;
const selectFabricationQuoteStep = (state) => state.fabrication?.quoteStep;
const selectFabricationQuote = (state) => state.fabrication?.quote;
const selectFabricationDestroy = (state) => state.fabrication?.destroy;
const selectFabricationLineItemId = (state) => state.fabrication?.lineItemId;

export const selectFabricationCurrentVariant = (state) => state.fabrication?.currentVariant;
export const selectFabricationQuantities = (state) => state.fabrication?.parametersCustomer?.quantities;

export const selectFabricationDataForCart = createSelector([
  selectFabricationParametersCustomer,
  selectFabricationQuoteStep,
  selectFabricationQuote,
  selectFabricationCurrentVariant,
  selectFabricationDestroy,
  selectFabricationLineItemId,
  ], (
    parameters,
    quoteStep,
    quote,
    currentVariant,
    destroy,
    lineItemId,
  ) => {

    const items_to_destroy = destroy && lineItemId ? [lineItemId] : [];
    const data_for_forms = {quoteStep, fabricationVariant: currentVariant}

    return{
      partNumber: parameters?.part_number,
      revision: parameters?.revision,
      fabProps: extractFabrication({parameters, quoteStep, quote}),
      fabToDestroy: items_to_destroy,
      fabDataForForms: data_for_forms,
    }
  }
);
